import React, {
    Component,
} from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';

import { DirectionsMap } from 'wanderu-component-directions';
import {
    localize,
} from 'wanderu-i18n';
import {
    durationToHoursAndMinutes,
} from 'wanderu-utils';

import styles from './Transfer.scss';

class Transfer extends Component {
    static propTypes = {
        arriveStationId: PropTypes.string,
        arriveTimestamp: PropTypes.string.isRequired,
        departStationId: PropTypes.string,
        departTimestamp: PropTypes.string.isRequired,
        nearby: PropTypes.bool,
        type: PropTypes.string.isRequired,
    };

    static defaultProps = {
        arriveStationId: '',
        departStationId: '',
        nearby: false,
    };

    render() {
        const {
            t,
            arriveStationId,
            arriveTimestamp,
            departStationId,
            departTimestamp,
            type,
            itineraryType,
            nearby,
            tripId,
        } = this.props;
        const arrive = moment.parseZone(arriveTimestamp).valueOf();
        const depart = moment.parseZone(departTimestamp).valueOf();
        const selfTransfer = type === 'selfTransfer';
        const duration = selfTransfer
            ? moment.duration(arrive - depart)
            : moment.duration(depart - arrive);
        const hoursAndMinutes = durationToHoursAndMinutes(duration);
        const durationString = t('baseApp:trip-duration_hours', hoursAndMinutes);
        const instructions = selfTransfer
            ? t('baseApp:routed-trip-layover_tripDetails', {
                duration: durationString,
            })
            : t('baseApp:potentialVehicleTransfer_tripDetails');

        return (
            <div className={styles.transfer}>
                <div className={styles.transferDuration}>
                    <div>
                        {t('baseApp:includes-transfers')}
                    </div>
                    <div>
                        {durationString}
                    </div>
                </div>
                <div className={styles.transferLineContainer}>
                    <div className={styles.transferEndpoint} />
                    <div className={styles.transferLine} />
                    <div className={styles.transferEndpoint} />
                </div>
                <div className={styles.transferInstructions}>
                    {instructions}
                    {selfTransfer && (
                        <DirectionsMap
                            arriveStationId={arriveStationId}
                            buttonText={t('baseApp:show-directions_tripDetails')}
                            className={styles.directionsLink}
                            departStationId={departStationId}
                            nearby={nearby}
                            tripId={tripId}
                            type={itineraryType}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export { Transfer };
export default localize(Transfer, ['t']);
